"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmHeader = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const useResize_1 = require("../hooks/useResize");
exports.SmHeader = (0, react_1.forwardRef)((_a, ref) => {
    var { mobileRender, logoRender, isFixed, isFlat, className, children } = _a, props = __rest(_a, ["mobileRender", "logoRender", "isFixed", "isFlat", "className", "children"]);
    const { width } = (0, useResize_1.useWindowSize)();
    const [isScrolled, setScrolled] = (0, react_1.useState)(false);
    const [isCollapsed, setCollapsed] = (0, react_1.useState)(false);
    (0, react_1.useMemo)(() => {
        const onScroll = () => {
            return isFixed ? setScrolled(window.scrollY !== 0) : undefined;
        };
        // clean up code
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, [isFixed]);
    const headerClassnames = (0, classnames_1.default)('c-header', {
        '-flat': isFlat,
        'position-fixed': isFixed,
        'o-shadow-level-100': isFixed && isScrolled,
    }, className);
    const collapseButtonClassnames = (0, classnames_1.default)('c-header__button', {
        '-opened': isCollapsed,
    });
    const isDesktop = (0, react_1.useMemo)(() => {
        return width > 767;
    }, [width]);
    const mobileRendering = (0, react_1.useMemo)(() => {
        const collapsibleClassnames = (0, classnames_1.default)('c-header__collapsible', {
            '-opened': isCollapsed,
        });
        return !isFlat ? (react_1.default.createElement("header", Object.assign({}, props, { ref: ref, className: headerClassnames }),
            logoRender,
            mobileRender || (react_1.default.createElement(react_1.default.Fragment, null, children && (react_1.default.createElement("button", { type: "button", className: collapseButtonClassnames, style: { marginLeft: 'auto' }, onClick: () => setCollapsed(!isCollapsed) },
                react_1.default.createElement("span", null),
                react_1.default.createElement("span", null),
                react_1.default.createElement("span", null))))),
            children && react_1.default.createElement("nav", { className: collapsibleClassnames }, children))) : (react_1.default.createElement("header", Object.assign({}, props, { ref: ref, className: headerClassnames }), children));
    }, [headerClassnames, isCollapsed, isFlat]);
    const desktopRendering = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement("header", Object.assign({}, props, { ref: ref, className: headerClassnames }),
            logoRender,
            children));
    }, [headerClassnames]);
    return isDesktop ? desktopRendering : mobileRendering;
});
//# sourceMappingURL=index.js.map